<template>
    <transition name="forward">
    <div id="delivery" v-show="show">
        <div class="back" @click="back()"></div>
        <div id="MapContainer"></div>
        <div class="contact">
            <div class="store">
                <span class="name">联系商家</span>
                <br>
                <a :href="'tel:'+storeInfo.tel" class="tel">{{storeInfo.tel}}</a>
            </div>
            <div class="qishou">
                <span class="name">联系骑手</span>
                <br>
                <a :href="'tel:'+qishou.tel" class="tel">{{qishou.tel}}&nbsp;{{qishou.name}}</a>
            </div>
        </div>
    </div>
    </transition>
</template>

<script>
    import {initAMapApiLoader,lazyAMapApiLoaderInstance} from './AMapApiInstance'
    import http from '../../service/ServiceHttp'
    import math from 'mathjs'

    initAMapApiLoader();


    export default {
        name: "Delivery",
        data() {
            return {
                show:false,
                map:undefined,
                homeMarker:undefined,
                qsMarkerPoint:undefined,
                qsMarkerHint:undefined,
                updateQSInfoInterval:undefined,
                refreshQSInfoInterval:undefined,
                lastQSPoint:{lat:'',lnt:''},
                count:0,
                qishou:{
                    tel:"",
                    name:""
                },
                loadApiPromise:undefined
            }
        },
        components: {
        },
        props:{
            storeInfo:{
                type:Object,
                tel:""
            },
            dispatchId:String
        },
        methods: {
            initMap(lng,lat) {
                this.map = new AMap.Map("delivery", {
                    resizeEnable: true,
                    center:[lng,lat],
                    zoom:18
                });
            },
            back(){
              this.stopInterval();
            },
            //添加用户家的位置(配送的目的地址)
            addHomeMarker(lng,lat) {
                this.homeMarker = new AMap.Marker({
                    icon: require('./home.png'),
                    position: [lng,lat],
                    offset: new AMap.Pixel(0, 0)
                });
                this.homeMarker.setMap(this.map);
            },
            //更新骑手位置
            updateQSMarker(lng, lat,distance,time) {
                let position = [lng, lat];
                let content = "";
                if(distance<0){
                     content = '<div class="qs-point">骑手正在送货<div class="hint"><span class="distance">距您千里之外</span></div></div>';
                }else{
                     content = '<div class="qs-point">骑手正在送货<div class="hint"><span class="distance">距您'+distance+'km</span><span class="time">'+time+'分钟</span></div></div>';
                }
                if (!this.qsMarkerHint || !this.qsMarkerPoint) {
                    this.qsMarkerHint = new AMap.Marker({
                        content: content,
                        position: position,
                        offset: new AMap.Pixel(-60, 50)
                    });
                    this.map.setCenter(position);

                    console.log("qs::",this.map);
                    this.qsMarkerHint.setMap(this.map);
                    this.qsMarkerPoint = new AMap.Marker({
                        icon: require("./qishou.png"),
                        position: position,
                        offset: new AMap.Pixel(-28, -20)
                    });
                    this.qsMarkerPoint.setMap(this.map);
                } else {
                    this.map.setCenter(position);
                    this.qsMarkerHint.setContent(content);
                    this.qsMarkerHint.setPosition(position);
                    this.qsMarkerPoint.setPosition(position);
                }
            },
            //刷新骑手位置
            refreshQSDeliverInfo(){
                if(!this.dispatchId || this.dispatchId=='') return;
                http.refreshQSDeliveryInfo(this.dispatchId,res=>{
                    let userPoint = {
                        lng:res.userGDLng,
                        lat:res.userGDLat
                    },
                    qsPoint = {
                        lng:res.dmGDLng,
                        lat:res.dmGDLat
                    };
                    if(!qsPoint.lat || !qsPoint.lng){
                        qsPoint.lng=res.storeGDLng;
                        qsPoint.lat=res.storeGDLat;
                    }
                    this.qishou.tel = res.dmMobile;
                    this.qishou.name = res.dmName;
                    if(this.count==0){
                        if(!lazyAMapApiLoaderInstance.loaded) return;
                        this.initMap(qsPoint.lng,qsPoint.lat);
                        this.addHomeMarker(userPoint.lng,userPoint.lat);
                        this.count++;
                    }else if(this.count>=60){
                        this.stopInterval();
                    }
                    if(this.lastQSPoint.lat==qsPoint.lat && this.lastQSPoint.lng==qsPoint.lng){
                        console.log("骑手位置未更新...");
                    } else {
                        http.calculateDistanceByGdMap(qsPoint, userPoint, (d, t) => {
                            if(d<0){
                                this.updateQSMarker(res.dmGDLng, res.dmGDLat, -1, -1);
                            }else {
                                d = math.round(d / 1000, 1);
                                t = t <= 60 ? 1 : (math.round(t / 60, 1));
                                this.updateQSMarker(res.dmGDLng, res.dmGDLat, d, t);
                            }
                        });
                    }
                    this.lastQSPoint.lat = res.dmGDLat;
                    this.lastQSPoint.lng = res.dmGDLng;
                })
            },
            updateQSDeliveryInfo() {
                if(!this.dispatchId || this.dispatchId=='') { return; }
                http.notifyServerUpdateQSDeliveryInfo(this.dispatchId);
            },
            //开始定时器
            startInterval(){
                this.show = true;
//                if(!lazyAMapApiLoaderInstance.loaded){
//                    this.loadApiPromise.then(() => {
//                        this.startInterval();
//                    });
//                    return;
//                } ;
                this.updateQSDeliveryInfo();
                this.refreshQSDeliverInfo();
                //2分钟查询配送方物流信息更新到我方库
                this.updateQSInfoInterval = window.setInterval(()=>{
                    updateQSDeliveryInfo(this.dispatchId);
                },2*60*1000);
                //10秒刷新一次
                this.refreshQSInfoInterval = window.setInterval(()=>{
                    this.refreshQSDeliverInfo();
                },60*1000);
            },
            stopInterval(){
                if(this.updateQSInfoInterval){window.clearInterval(this.updateQSInfoInterval);}
                if(this.refreshQSInfoInterval){window.clearInterval(this.refreshQSInfoInterval);}
                this.count = 1;
                this.show = false;
            }
        },
        mounted(){
            console.log("mounted....");
            this.loadApiPromise = lazyAMapApiLoaderInstance.load();
//            this.loadApiPromise.then(() => {
//             this.startInterval();
//                this.initMap(121.42509,31.20169);
//                this.addHomeMarker(121.42509,31.20161);
//                this.updateQSMarker(121.42509,31.20169,10,10);
//            });
        },
        beforeDestroy(){
            console.log("beforeDestroy");
        }
    }
</script>

<style lang="scss" >
#delivery{
    position: absolute;
    top:0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 16;
    background-color: #ffffff;
    .back{
        position: absolute;
        left: 20px;
        top: 20px;
        width: 15px;
        height: 15px;
        border-top: 3px solid rgba(0,0,0,0.7);
        border-right: 3px solid rgba(0,0,0,0.7);
        transform: rotate(-135deg);
        z-index: 99999;
    }
    .amap-icon img{
        height: 64px;
    }
    .qs-point{
        width: 120px;
        background: rgba(0,0,0,0.7);
        text-align: center;
        color: white;
        border-radius: 5px;
        padding: 5px;
        border:1px solid #D7DADB;
        font-size: 1rem;
        .hint{
            font-size: 0.7rem;
            color: #cdcdcd;
            span{
                margin-left: 5px;
                color: #ffc900;
            }
        }
    }
    .qs-point:before, .qs-point:after {
        content: "";
        position: absolute;
        border-style: dashed dashed solid dashed;
        line-height: 1;
        display: inline-block;
    }
    .qs-point:after {
        left: 60px;
        border-color: transparent transparent #D7DADB;
        border-width: 11px;
        top: -22px;
        z-index: 1080;
    }
    .qs-point:before {
        left: 60px;
        border-color: transparent transparent rgba(0,0,0,0.7);
        border-width: 10px;
        top: -19px;
        z-index: 1081;
    }
    .contact{
        position: fixed;
        left: 10px;
        right: 10px;
        bottom: 10px;
        background: rgba(0,0,0,0.8);
        color: #FFFFFF;
        z-index: 1080;
        border-radius: 5px;
        display: flex;
        padding: 5px;
        .store{
            flex: 1;
            text-align: center;
            border-right: 1px solid #666666;
        }
        .qishou{
            flex: 1;
            text-align: center;
        }
        .name{
            color: #999999;
            font-size: 0.8rem;
        }
        .tel{
            color: #bf9600;
            font-size: 0.9rem;
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/deliveryDetail/qishou.vue